import type { TermKind } from "../rdf/types";
import { KIND_STYLE } from "./kind-style";

export default function KindBadge({ kind }: { kind: TermKind }) {
  const style = KIND_STYLE[kind];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{
        color: style.color,
        backgroundColor: `${style.color}1a`,
        border: `1px solid ${style.color}40`,
      }}
    >
      <span aria-hidden="true">{style.glyph}</span>
      {style.label}
    </span>
  );
}
